import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { breadcrumbsSelector } from '../../selectors/breadcrumbs.selectors';

const Breadcrumbs = () => {
  const breadcrumbs = useSelector(breadcrumbsSelector);
  return (
    <ul className="m-breadcrumbs">
      {breadcrumbs?.map((b, i) => (
        <li key={`${b.name}_${i}`}>{b.target ? <Link to={b.target}>{b.name}</Link> : b.name}</li>
      )) ?? []}
    </ul>
  );
};

export default Breadcrumbs;
